"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmeraldListItemVariant = void 0;
var EmeraldListItemVariant;
(function (EmeraldListItemVariant) {
    EmeraldListItemVariant["DEFAULT"] = "default";
    EmeraldListItemVariant["CHECKBOX"] = "checkbox";
    EmeraldListItemVariant["RADIO"] = "radio";
    EmeraldListItemVariant["SWITCH"] = "switch";
    EmeraldListItemVariant["AVATAR"] = "avatar";
    EmeraldListItemVariant["LINK"] = "link";
    EmeraldListItemVariant["ICON"] = "icon";
})(EmeraldListItemVariant || (exports.EmeraldListItemVariant = EmeraldListItemVariant = {}));
//# sourceMappingURL=list-item.variant.js.map